import * as odata from './odata.js';
const FEEDS = {
    PROJECTS_FEED: 'https://informea.pops.int/Projects/Projects.svc',
};
const GROUPS_MAPPINGS = {
    'government agency/organization': 'Government agency',
    'private sector': 'Private sector',
    'sovereign state': 'Government',
    'united nations body': 'united nations',
};
const defaultProjectsService = new odata.ODataService(FEEDS.PROJECTS_FEED);
export const getProjects = async (projectsService) => {
    projectsService ??= defaultProjectsService;
    const projectsQuery = new odata.ODataQuery(projectsService, 'Projects', {
        $expand: 'Terms, Beneficiaries, Donors, Implementedby',
        $filter: 'Terms/any(x: x/termId eq guid\'5f98dd47-86e5-e311-86cc-0050569d5de3\')',
    });
    const convertStatus = (rawStatus) => {
        switch (rawStatus) {
            case 'being initiated': {
                return 'not_started';
            }
            case 'ongoing': {
                return 'on_going';
            }
            case 'completed': {
                return 'completed';
            }
            default: {
                throw new Error(`Unknown status: ${rawStatus}`);
            }
        }
    };
    const categoryMapping = (category) => GROUPS_MAPPINGS[category.toLowerCase()] ?? category;
    const processRaw = (raw) => ({
        type: 'brs',
        id: 'brs-' + raw.id,
        feedId: raw.id,
        sourceDate: new Date(),
        name: raw.name,
        status: convertStatus(raw.statusName),
        beneficiaries: raw.Beneficiaries.map(b => ({
            iso2: b.country,
            name: b.countryNameEn,
            countryRegionUn: b.countryRegionUn,
            isSIDS: b.isSIDS,
            isLDC: b.isLDC,
            isDeveloping: b.isDeveloping,
        })),
        description: raw.description,
        startDate: raw.datestart ? new Date(raw.datestart) : undefined,
        endDate: raw.dateend ? new Date(raw.dateend) : undefined,
        budget: Number.parseInt(raw.budget?.replace(/,/g, ''), 10),
        isGlobal: raw.isGlobal,
        url: raw.webpage,
        imageUrl: raw.imagesurl,
        donors: raw.Donors.map((d) => ({
            name: d.Name,
            category: categoryMapping(d.categoryName),
            url: d.web,
        })),
        implementedBy: raw.Implementedby.map((i) => ({
            name: i.Name,
            category: categoryMapping(i.categoryName),
            url: i.web,
        })),
        keywords: raw.Terms.map((t) => ({
            name: t.term,
        })),
        isUmbrella: raw.isUmbrella,
        umbrellaId: raw.umbrellaId ? ('brs-' + raw.umbrellaId) : undefined,
        brs_umbrellaName: raw.umbrellaName,
        brs_objectives: raw.objectives,
        brs_activities: raw.activities,
    });
    const data = await projectsQuery.execute();
    return data.map(raw => processRaw(raw));
};
export const getUniqueItems = (projects, key) => {
    const keys = new Set();
    const items = [];
    for (const p of projects) {
        const projectItems = p[key];
        if (!projectItems) {
            continue;
        }
        for (const item of projectItems) {
            if (keys.has(item.name)) {
                continue;
            }
            keys.add(item.name);
            items.push(item);
        }
    }
    return items.sort((a, b) => a.name.localeCompare(b.name));
};
export const getTerms = (projects) => getUniqueItems(projects, 'keywords');
export const getImplementedBy = (projects) => getUniqueItems(projects, 'implementedBy');
export const getCountries = (projects) => getUniqueItems(projects, 'beneficiaries');
export const getDonors = (projects) => getUniqueItems(projects, 'donors');
//# sourceMappingURL=brs.js.map